const sharedStringsStrings = {
    placeOrder: "Place Order",
    viewMenu: "View Menu",
    takeMeThere: "Take Me There",
};

export default sharedStringsStrings;
